import { isBrowser } from 'utils';

export const getScrollbarWidth = () => {
  if (!isBrowser()) {
    return 0;
  }
  return window.innerWidth - document.documentElement.clientWidth;
};
